import React, { Component } from "react";
import { Col, Card, Form } from "antd";
import _ from "lodash";
class RuangNego extends Component {
  render() {
    const { calculation, formatRupiah, getValue, request, isTrust } =
      this.props;
    const mrp = _.find(request, { status_label: "MRP", status: "Approved" });
    let fields = isTrust
      ? ["Harga Penawaran", "Ruang Nego", "Harga Final"]
      : ["Harga Penawaran"];
    return calculation ? (
      <Col xs={24} md={12}>
        <Card title="Ruang Nego Harga">
          {fields.map((v, i) => (
            <Form.Item
              label={v === "Harga Final" ? "MRP (Harga Max)" : v}
              key={v}>
              <span className="ant-form-text form-text-mod">
                {formatRupiah(getValue(calculation, "name", v))}
              </span>
            </Form.Item>
          ))}
          {getValue(calculation, "name", "Koreksi MRP") && mrp ? (
            <Form.Item label="Koreksi MRP">
              <span className="ant-form-text form-text-mod">
                {formatRupiah(getValue(calculation, "name", "Koreksi MRP"))}
              </span>
            </Form.Item>
          ) : null}
        </Card>
      </Col>
    ) : null;
  }
}

export default RuangNego;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/RuangNego.js